import React from 'react';
import { ChevronRight } from 'lucide-react';

const SidebarItem = ({
  icon: Icon,
  label,
  isActive = false,
  onClick,
  hasSubItems = false,
  isExpanded = false,
  onToggle,
  badge,
  disabled = false,
  className = ''
}) => {
  // Debug logging
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (disabled) return;

    // For items with sub-items, only toggle expansion, don't navigate
    if (hasSubItems && onToggle) {
      onToggle(); // Only expand/collapse
    } else if (onClick) {
      onClick(); // Only navigate for items without sub-items
    }
  };

  const baseClasses = 'sidebar-item w-full text-left';
  const activeClasses = isActive ? 'sidebar-item-active bg-green-500 text-white' : 'sidebar-item-inactive';
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';

  // Inline styles as fallback to ensure colors are always applied
  const inlineStyles = isActive ? {
    backgroundColor: '#22c55e !important',
    color: 'white !important',
    borderRadius: '0.5rem',
    padding: '0.5rem 0.75rem',
    '--tw-bg-opacity': '1',
    '--tw-text-opacity': '1'
  } : {};

  return (
    <div
      className={`${baseClasses} ${activeClasses} ${disabledClasses} ${className}`}
      style={inlineStyles}
      data-active={isActive}
    >
      <div
        className="flex items-center justify-between w-full"
        onClick={handleClick}
      >
        <div className="flex items-center flex-1 min-w-0">
          {Icon && (
            <Icon
              className="h-4 w-4 sm:h-5 sm:w-5 mr-2 sm:mr-3 flex-shrink-0"
              style={isActive ? { color: 'white' } : {}}
            />
          )}
          <span
            className="text-xs sm:text-sm leading-tight truncate"
            style={isActive ? { color: 'white' } : {}}
          >
            {label}
          </span>
          {badge && (
            <span className="ml-1 sm:ml-2 px-1.5 sm:px-2 py-0.5 text-xs font-medium bg-red-100 text-red-800 rounded-full">
              {badge}
            </span>
          )}
        </div>
        {hasSubItems && (
          <ChevronRight
            className={`h-3 w-3 sm:h-4 sm:w-4 transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''
              }`}
          />
        )}
      </div>
    </div>
  );
};

export default SidebarItem;
